/**
    商品列表
**/
<template>
  <div class="rightaside_content">
  <h3 class="headerTitle">我的积分</h3>
  <el-divider></el-divider>
        <el-row :gutter="20">
        <el-col :span="24">
            <p>可用积分： <i class="pointNum">{{getUserPays}}</i></p>
        </el-col>  
        <el-col><el-divider></el-divider></el-col>
        <el-col v-loading='loading'>
            <el-table
                    :data="tableData"
                    style="width: 100%">
                    <el-table-column  prop="createTime" label="添加时间"> </el-table-column>
                    <el-table-column  prop="experience" label="积分变更"> </el-table-column>
                    <el-table-column  prop="description" label="描述">
                        <template slot-scope="scope">
                        <span>{{integralType(scope.row.integralType)}}</span>
                      </template>
                     </el-table-column>
                    
                </el-table>
        </el-col>
        <el-col :span="24" class="pagination">
                <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
            </el-col>
        </el-row> 
  </div>
</template>
<script>
import Pagination from '@/components/Pagination'
import {integralList,getUserPay} from "@/api/xunyou";
export default {
  data() {
    return {
        loading:false,
       tableData: [
        ],
        getUserPays:0,
     // 请求数据参数
        formInline: {
            pageSize: 10,
            pageNum: 1,
            uid:JSON.parse(localStorage.getItem("userdata")).userId,
        },
        // 分页参数
        pageparm:{
            pageSize:10,
            currentPage:1,
            total:0,
        },
    };
  },
    // 注册组件
  components: {Pagination},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
      this.getintegralList()
      this.getUserMoney()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    integralType(status){
				 switch(status) {
				    case 1:
				       return  '会员注册'
				           break;
				       case 2:
				            return '订单评论'
				           break;
				       case 3:
				            return '会员登录'
				           break;
				       case 4:
				            return '消费赠送'
							break;
						case 5:
						     return '积分换购商品'
						    break;
						case 6:
						     return '管理员操作'
						case 7:
						     return '退款扣除'
				       default:                
				           return '--'    
				   }     
		},
       // 分页插件事件
    callFather(parm) {
      this.formInline.pageNum = parm.currentPage
      this.formInline.pageSize = parm.pageSize
      this.getintegralList(this.activeName)
    },
   getintegralList() {
            this.loading = true
            integralList(this.formInline)
              .then((res) => {
                  if (res.code == 0) {
                      this.loading = false
                    this.tableData = res.rows
                    this.pageparm.currentPage = this.formInline.pageNum
                    this.pageparm.pageSize = this.formInline.pageSize
                    this.pageparm.total = res.total
                }
              })
              .catch((err) => {
                this.$message.error("查询商品列表失败，请稍后再试！");
              });
          },
     // 查询用户的有关金额
    getUserMoney(){
        getUserPay(
            {
                userId:JSON.parse(localStorage.getItem("userdata")).userId,
            }
        )
            .then(res => {
                console.log(res,'查询用户的有关金额')
                this.getUserPays=res.data.userPoints
            })
            .catch(err => {
              this.$message.error('查询用户的有关金额失败，请稍后再试！')
            })
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
    // padding: 30px 0;
    // box-sizing: border-box;
    .headerTitle {
        font-size: 20px;
        height: 40px;
        line-height: 40px;
        color: #666;
    }
    i.pointNum {
        font-size: 42px;
        font-weight: 600;
    }
    .pagination{
        text-align: right;
        /deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #ff6700;
            color: #FFF;
            width: 20px;
        }
        /deep/.el-pagination.is-background .btn-next, /deep/.el-pagination.is-background .btn-prev, /deep/.el-pagination.is-background .el-pager li {
            width: 20px;
        }
        /deep/input[disabled], input[disabled="disabled"], input[readonly], input[readonly="readonly"] {
            background-color: transparent;
        }
        }
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/propertyCenter/myScores.vue